/**
 * True when the app should show demo data (is_demo = true).
 *
 * Demo domains:  demo.luster.company, localhost, 127.0.0.1
 * Production:    portal.luster.company (and any other hostname)
 *
 * Override: set VITE_FORCE_LIVE_SITE=true in .env.local to treat localhost as
 * "live" so Live-scope branding is visible when testing locally.
 */
export function isDemoSite(): boolean {
  if (import.meta.env.VITE_FORCE_LIVE_SITE === "true") return false
  if (typeof window !== "undefined" && window.location?.hostname) {
    const h = window.location.hostname
    return h === "demo.luster.company" || h === "localhost" || h === "127.0.0.1"
  }
  return (import.meta.env.VITE_IS_DEMO_SITE === "true") as boolean
}

/** The production app domain — used for login redirects and links. */
export const APP_DOMAIN = "portal.luster.company"
export const DEMO_DOMAIN = "demo.luster.company"

